import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/operated/report',
  owner: '/home',
  authority: 'report',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};